import { static_options } from './options';

export const filterOption = (input: any, option: any) => {
  return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

// 流量池——搜索
export const seeding_form_list: any = {
  name: { tag_name: 'a-input', key: 'name', label: '姓名', value: undefined, bind: { placeholder: '请输入' } },
  mobile: { tag_name: 'a-input', key: 'mobile', label: '手机号', value: undefined, bind: { placeholder: '请输入' } },
  corp_name: { tag_name: 'a-input', key: 'corp_name', label: '公司', value: undefined, bind: { placeholder: '请输入' } },
  corp_position: { tag_name: 'a-input', key: 'corp_position', label: '职位', value: undefined, bind: { placeholder: '请输入' } },
  income: { tag_name: 'a-input', key: 'income', label: '年营收', value: { first: undefined, second: undefined }, bind: { placeholder: '请输入' } },
  charge_teacher_id: {
    tag_name: 'a-select',
    key: 'charge_teacher_id',
    label: '负责班主任',
    value: [],
    bind: { placeholder: '请输入', mode: 'multiple', optionLabelProp: 'children', filterOption: filterOption },
    options: []
  },
  online_status: {
    tag_name: 'a-select',
    key: 'online_status',
    label: '线上学籍',
    value: undefined,
    bind: { placeholder: '请输入' },
    options: [...static_options.online_status]
  },
  tag_id: {
    tag_name: 'el-cascader',
    key: 'tag_id',
    label: '标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true
    }
  },
  tag_id_chuang: {
    tag_name: 'el-cascader',
    key: 'tag_id_chaung',
    label: '创商标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true
    }
  },
  type: { tag_name: 'a-select', key: 'type', label: '创商跟进分类', value: undefined, bind: { placeholder: '请输入' }, options: [] },
  followup: { tag_name: 'a-input', key: 'followup', label: '跟进筛选', value: undefined, bind: { placeholder: '请输入' } },
  callback_time: { tag_name: 'a-range-picker', key: 'callback_time', label: '回访时间', value: [] }
};

// 招生列表——搜索
export const recruition_form_list: any = {
  name: { tag_name: 'a-input', key: 'name', label: '姓名', value: undefined, bind: { placeholder: '请输入' } },
  mobile: { tag_name: 'a-input', key: 'mobile', label: '手机号', value: undefined, bind: { placeholder: '请输入' } },
  corp_name: { tag_name: 'a-input', key: 'corp_name', label: '公司', value: undefined, bind: { placeholder: '请输入' } },
  corp_position: { tag_name: 'a-input', key: 'corp_position', label: '职位', value: undefined, bind: { placeholder: '请输入' } },
  income: { tag_name: 'a-input', key: 'income', label: '年营收', value: { first: undefined, second: undefined }, bind: { placeholder: '请输入' } },
  charger_id: {
    tag_name: 'a-select',
    key: 'charger_id',
    label: '转化负责人',
    value: [],
    bind: { placeholder: '请输入', mode: 'multiple', optionLabelProp: 'children', filterOption: filterOption },
    options: []
  },
  status: {
    tag_name: 'a-select',
    key: 'status',
    label: '项目跟进状态',
    value: undefined,
    bind: { placeholder: '请输入' },
    options: [...static_options.status, { value: -1, label: '无' }]
  },
  followup: { tag_name: 'a-input', key: 'followup', label: '跟进筛选', value: undefined, bind: { placeholder: '请输入' } },
  target_periods: { tag_name: 'a-input', key: 'target_periods', label: '目标期数', value: undefined, bind: { placeholder: '请输入' } },
  interviewer: { tag_name: 'a-input', key: 'interviewer', label: '面试官', value: undefined, bind: { placeholder: '请输入' } },
  fee_channel: {
    tag_name: 'a-select',
    key: 'fee_channel',
    label: '缴费渠道',
    value: undefined,
    bind: { placeholder: '请输入' },
    options: [...static_options.fee_channel, { value: -1, label: '无' }]
  },
  interview_time: { tag_name: 'a-range-picker', key: 'interview_time', label: '面试时间', value: [] },
  time: { tag_name: 'a-range-picker', key: 'time', label: '创商回访时间', value: [] },
  source: {
    tag_name: 'a-select',
    key: 'source',
    label: '来源',
    value: [],
    bind: { placeholder: '请输入', mode: 'multiple', optionLabelProp: 'children', filterOption: filterOption },
    options: static_options.source
  },
  source_desc: { tag_name: 'a-input', key: 'source_desc', label: '来源说明', value: undefined, bind: { placeholder: '请输入' } },
  tag_id: {
    tag_name: 'el-cascader',
    key: 'tag_id',
    label: '标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true,
      clearable: true
    }
  },
  tag_id_chuang: {
    tag_name: 'el-cascader',
    key: 'tag_id_chaung',
    label: '创商标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true
    }
  }
};

// 交付列表——搜索
export const delivery_form_list: any = {
  name: { tag_name: 'a-input', key: 'name', label: '姓名', value: undefined, bind: { placeholder: '请输入' } },
  mobile: { tag_name: 'a-input', key: 'mobile', label: '手机号', value: undefined, bind: { placeholder: '请输入' } },
  corp_name: { tag_name: 'a-input', key: 'corp_name', label: '公司', value: undefined, bind: { placeholder: '请输入' } },
  corp_position: { tag_name: 'a-input', key: 'corp_position', label: '职位', value: undefined, bind: { placeholder: '请输入' } },
  income: { tag_name: 'a-input', key: 'income', label: '年营收', value: { first: undefined, second: undefined }, bind: { placeholder: '请输入' } },
  fee: { tag_name: 'a-input', key: 'fee', label: '缴费区间', value: { first: undefined, second: undefined }, bind: { placeholder: '请输入' } },
  // undelivered_module: {
  //   tag_name: 'a-select',
  //   key: 'undelivered_module',
  //   label: '未交付模块',
  //   value: [],
  //   bind: { placeholder: '请输入', mode: 'multiple', optionLabelProp: 'children', filterOption: filterOption },
  //   options: [...static_options.undelivered_module, { value: -1, label: '无' }]
  // },
  teacher_id: {
    tag_name: 'a-select',
    key: 'teacher_id',
    label: '创商班主任',
    value: [],
    bind: { placeholder: '请选择' },
    options: []
  },
  class_period: { tag_name: 'a-input', key: 'class_period', label: '班期', value: undefined, bind: { placeholder: '请输入' } },
  gender: {
    tag_name: 'a-select',
    key: 'teacher_id',
    label: '性别',
    value: undefined,
    bind: { placeholder: '请输入' },
    options: [...static_options.gender, { value: -1, label: '无' }]
  },
  study_expectation: { tag_name: 'a-input', key: 'study_expectation', label: '学习期待', value: undefined, bind: { placeholder: '请输入' } },
  solution_progress: { tag_name: 'a-input', key: 'solution_progress', label: '交付方案进展', value: undefined, bind: { placeholder: '请输入' } },
  helping_progress: { tag_name: 'a-input', key: 'helping_progress', label: '互助进展', value: undefined, bind: { placeholder: '请输入' } },
  interview_records: { tag_name: 'a-input', key: 'interview_records', label: '面试记录', value: undefined, bind: { placeholder: '请输入' } },
  // cloth_size: {
  //   tag_name: 'a-select',
  //   key: 'cloth_size',
  //   label: '衣服尺码',
  //   value: [],
  //   bind: { placeholder: '请输入', mode: 'multiple' },
  //   options: [...static_options.cloth_size, { value: -1, label: '无' }]
  // },
  industry: { tag_name: 'a-input', key: 'industry', label: '行业', value: undefined, bind: { placeholder: '请输入' } },
  source: {
    tag_name: 'a-select',
    key: 'source',
    label: '来源',
    value: undefined,
    bind: { placeholder: '请输入' },
    options: [...static_options.source]
  },
  source_desc: { tag_name: 'a-input', key: 'source_desc', label: '来源说明', value: undefined, bind: { placeholder: '请输入' } },
  tag_id: {
    tag_name: 'el-cascader',
    key: 'tag_id',
    label: '标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true
    }
  },
  tag_id_chuang: {
    tag_name: 'el-cascader',
    key: 'tag_id_chuang',
    label: '创商标签',
    value: [],
    bind: {
      placeholder: '请输入',
      options: [],
      props: { label: 'tag_name', value: 'id', children: 'parent', multiple: true },
      size: 'small',
      style: 'width:100%',
      collapseTags: true
    }
  },
  birthday_time: { tag_name: 'a-range-picker', key: 'birthday_time', label: '生日', value: [] }
};
